import clsx from "clsx";
import { FieldValues, Path, UnPackAsyncDefaultValues, UseFormRegister, UseFormSetFocus } from "react-hook-form";
import { ChangeEvent, useEffect, FocusEvent } from "react";

type Size = "sm" | "md" | "lg";

export function TextboxInput<T extends FieldValues>(props: {
    register: UseFormRegister<T>;
    name: Path<UnPackAsyncDefaultValues<T>>;
    placeholder?: string;
    type?: string;
    min?: number;
    max?: number;
    step?: number;
    maxLength?: number;
    id?: string;
    required?: boolean;
    size?: Size;
    disabled?: boolean;
    autoFocus?: UseFormSetFocus<T>;
    hideNavbarOnFocus?: boolean;
    autoComplete?: string;
    pattern?: string;
    textArea?: boolean;
    rows?: number;
    className?: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}) {
    const {
        register,
        name,
        id = name,
        placeholder,
        min,
        max,
        step,
        required,
        maxLength,
        type = "text",
        size = "md",
        disabled,
        autoFocus,
        pattern,
        autoComplete = "off",
        textArea,
        rows,
        className,
        onChange,
        onBlur,
    } = props;

    useEffect(() => {
        if (autoFocus) {
            autoFocus(name);
        }
    }, [autoFocus, name]);

    const Tag = textArea ? "textarea" : "input";
    const t = textArea ? undefined : type;

    return (
        <Tag
            maxLength={maxLength}
            id={id}
            type={t}
            min={min}
            max={max}
            required={required}
            autoComplete={autoComplete}
            step={step}
            pattern={pattern}
            rows={rows}
            disabled={disabled}
            className={clsx(
                type === "range" ? "form-range" : "form-control",
                size === "lg" && "form-control-lg",
                size === "sm" && "form-control-sm",
                className,
            )}
            placeholder={placeholder}
            {...register(name, {
                valueAsNumber: type === "range" || type === "number",
                onChange: e => {
                    if (onChange) {
                        onChange(e);
                    }
                },
                onBlur: e => {
                    if (onBlur) {
                        onBlur(e);
                    }
                },
            })}
        />
    );
}
